module.exports = __webpack_public_path__ + "static/media/kido-logo.db89de0f.png";